export class DeleteProposalContentError extends Error {
}